// Ayarlar → Entegrasyonlar: ikas bağlantısı (müşteri bazlı). ikas panelinde oluşturulan Özel Uygulama'nın
// Client ID + Client Secret'ı ile bağlanır. Backend: /ai-advisor/ikas/* (ikas_router.py)
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { T, MONO } from './poyais-ui/theme';
import { Button } from './poyais-ui/primitives';
import { useLang, addTranslations } from './i18n';

addTranslations({
  'Bağlı': 'Connected',
  'Bağlı Değil': 'Not connected',
  'Mağaza adı': 'Store name',
  'Client ID': 'Client ID',
  'Client Secret': 'Client Secret',
  'ikas panelinde Uygulamalar → Uygulamalarım → Özel Uygulama Oluştur ile bir uygulama aç, gerekli (okuma) izinleri seç; çıkan Client ID ve Client Secret’ı gir. Yalnızca müşteri yöneticisi bağlayabilir.': 'In your ikas dashboard open Apps → My Apps → Create Private App, choose the (read) scopes you need and enter the Client ID and Client Secret. Only the client admin can connect.',
  'Bağlan': 'Connect',
  'Bağlantıyı Kes': 'Disconnect',
  'Bağlanıyor…': 'Connecting…',
  'ikas bağlantısını kesmek istediğine emin misin?': 'Disconnect ikas?',
});

const API = '/api/v1/ai-advisor/ikas';

const label: React.CSSProperties = { fontSize: 9, fontWeight: 700, color: T.accent, letterSpacing: '0.1em', textTransform: 'uppercase', fontFamily: 'Manrope, sans-serif', marginBottom: 6 };
const input: React.CSSProperties = { width: '100%', padding: '9px 12px', borderRadius: 8, border: `1px solid ${T.borderMid}`, fontSize: 12, fontFamily: 'Manrope, sans-serif', background: T.subtleBg, outline: 'none', color: T.text, boxSizing: 'border-box', marginBottom: 12 };

export default function IkasIntegrationCard({ clientId, embedded, onStatus }: { clientId: number; embedded?: boolean; onStatus?: (connected: boolean) => void }) {
  const { t } = useLang();
  const [status, setStatus] = useState<{ connected: boolean; store?: string } | null>(null);
  const [store, setStore] = useState(''); const [apiId, setApiId] = useState(''); const [apiSecret, setApiSecret] = useState('');
  const [busy, setBusy] = useState(false); const [err, setErr] = useState('');

  const load = () => axios.get(`${API}/status?client_id=${clientId}`).then(r => setStatus(r.data)).catch(() => setStatus({ connected: false }));
  useEffect(() => { load(); }, [clientId]); // eslint-disable-line react-hooks/exhaustive-deps

  const connect = async () => {
    setBusy(true); setErr('');
    try { await axios.post(`${API}/connect`, { client_id: clientId, store, api_client_id: apiId, api_client_secret: apiSecret }); setApiSecret(''); await load(); }
    catch (e: any) { setErr(e?.response?.data?.detail || 'Bağlantı kurulamadı.'); }
    finally { setBusy(false); }
  };
  const disconnect = async () => {
    if (!window.confirm(t('ikas bağlantısını kesmek istediğine emin misin?'))) return;
    await axios.post(`${API}/disconnect`, { client_id: clientId }).catch(() => {});
    load();
  };
  const on = !!status?.connected;
  useEffect(() => { if (status) onStatus?.(!!status.connected); }, [status]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={embedded ? undefined : { background: T.surface, borderRadius: 14, border: `1px solid ${T.border}`, padding: '20px 22px' }}>
      {!embedded && (<>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 16 }}>
        <div style={{ width: 40, height: 40, borderRadius: 10, background: T.trackBg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img src="/ikas-icon.png" width={22} height={22} style={{ objectFit: 'contain', borderRadius: 5 }} alt="ikas" />
        </div>
        <div style={{ marginTop: 2 }}>
          <span style={{ display: 'inline-block', padding: '3px 10px', borderRadius: 999, fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.08em',
            background: on ? T.greenTint : T.trackBg, color: on ? T.greenText : T.textMidAlt }}>{on ? t('Bağlı') : t('Bağlı Değil')}</span>
        </div>
      </div>
      <div style={{ fontSize: 14, fontWeight: 700, color: T.text, fontFamily: 'Manrope, sans-serif', marginBottom: 4 }}>ikas</div>
      </>)}
      {on ? (
        <div>
          <div style={{ fontSize: 11, color: T.greenText, fontWeight: 600, marginBottom: 4 }}><span style={{ fontFamily: MONO }}>{status?.store}.myikas.com</span></div>
          <div style={{ marginBottom: 10 }} />
          <button onClick={disconnect} style={{ width: '100%', padding: '9px 12px', borderRadius: 9, border: `1px solid ${T.redTint}`, background: T.redTint, color: T.redText, fontSize: 12, fontWeight: 700, cursor: 'pointer', fontFamily: 'Manrope, sans-serif' }}>
            {t('Bağlantıyı Kes')}
          </button>
        </div>
      ) : (
        <>
          <div style={{ fontSize: 11, color: T.textDim, lineHeight: 1.5, marginBottom: 12 }}>{t('ikas panelinde Uygulamalar → Uygulamalarım → Özel Uygulama Oluştur ile bir uygulama aç, gerekli (okuma) izinleri seç; çıkan Client ID ve Client Secret’ı gir. Yalnızca müşteri yöneticisi bağlayabilir.')}</div>
          <div style={label}>{t('Mağaza adı')}</div>
          <input style={input} value={store} onChange={e => setStore(e.target.value)} placeholder="magazaadi.myikas.com" />
          <div style={label}>{t('Client ID')}</div>
          <input style={input} value={apiId} onChange={e => setApiId(e.target.value)} placeholder="Client ID" autoComplete="off" />
          <div style={label}>{t('Client Secret')}</div>
          <input style={input} type="password" value={apiSecret} onChange={e => setApiSecret(e.target.value)} placeholder="Client Secret" autoComplete="new-password" />
          {err && <div style={{ fontSize: 11, color: T.redText, marginBottom: 8 }}>{err}</div>}
          <Button variant="solid" disabled={busy || !store || !apiId || !apiSecret} onClick={connect} style={{ width: '100%' }}>{busy ? t('Bağlanıyor…') : t('Bağlan')}</Button>
        </>
      )}
    </div>
  );
}
